import React, { useLayoutEffect } from 'react';
import { ListGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { useLocation, useSearchParams } from 'react-router-dom';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import { vendorActions } from '../../../features/Vendor/VendorSlice';
import './navbar.scss';

const NavLeft = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const animatedComponents = makeAnimated();
  const [searchParams] = useSearchParams();
  const { userVendors, currentVendor } = useSelector((state) => state.vendor);

  const allowedPaths = [
    '/',
    '/sku-breakdown',
    '/transfer-orders',
    '/feedback-orders',
    '/purchase-orders',
    '/purchase-receipts'
  ];

  function ChangeVendor(e) {
    const selectedVendor = userVendors.find((vend) => vend.identifier === e.value);
    dispatch(vendorActions.UpdateCurrentVendor(selectedVendor));
    Cookies.set('currentVendor', JSON.stringify(selectedVendor));
  }

  useLayoutEffect(() => {
    if (searchParams.get('vendorNo') && searchParams.get('vendorNo') !== '') {
      const selectedVendor = userVendors.find(
        (vend) =>
          vend.vendNo === searchParams.get('vendorNo') &&
          vend.VendorType.toLowerCase() === searchParams.get('VendorType') &&
          vend.companyBadgeText === searchParams.get('companyBadge')
      );
      dispatch(vendorActions.UpdateCurrentVendor(selectedVendor));
    } else {
      if (Cookies.get('currentVendor')) {
        const savedVendor = JSON.parse(Cookies.get('currentVendor'));
        if (
          Object.keys(currentVendor).length > 0 &&
          currentVendor.identifier !== savedVendor.identifier
        ) {
          dispatch(vendorActions.UpdateCurrentVendor(JSON.parse(Cookies.get('currentVendor'))));
        }
      }
    }
  });

  const selectOptions = userVendors.map((vendor) => {
    return {
      value: vendor.identifier,
      label: vendor.identifier,
      vendNo: vendor.vendNo
    };
  });

  const ShowVendorSwitch = allowedPaths.some((path) => {
    return path === location.pathname;
  });

  return (
    <React.Fragment>
      <ListGroup as="ul" className="navbar-nav mr-auto emma-navbar">
        {ShowVendorSwitch ? (
          <ListGroup.Item
            className="nav-item"
            style={{ backgroundColor: 'transparent', minWidth: '100px' }}
          >
            <Select
              components={animatedComponents}
              options={selectOptions}
              value={selectOptions.find((opt) => opt.value === currentVendor.identifier)}
              styles={{ minWidth: '100px' }}
              onChange={(e) => {
                ChangeVendor(e);
              }}
            />
          </ListGroup.Item>
        ) : (
          <></>
        )}
      </ListGroup>
    </React.Fragment>
  );
};

export default NavLeft;
